import axios from 'axios'
import qs from 'qs'
import {Toast} from 'vant'
import {ENV_ROOT_DEV} from './env.js'

const http = axios.create({
  baseURL: ENV_ROOT_DEV,
  timeout: 30000,
  headers:{
    'Content-type':'application/json'
  }
})
// http.defaults.headers.common['Authorization'] = 'Bearer ' + cookies.get('token')
http.interceptors.request.use(
  config => {
    window.krpano.call('skin_showloading(true)')
    // 在发送请求之前做某件事
    // 若是有做鉴权token , 就给头部带上token

    config.headers.token = JSON.parse(localStorage.getItem('token')) ? JSON.parse(localStorage.getItem('token')) : ''

    // if (localStorage.getItem('token')) {
    //   config.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    // }
    if (config.method === 'post') {
      // 序列化
      config.data = JSON.stringify(config.data) // ***** 这里转义
    }
    return config
  }, err =>{
  // return Promise.reject(err)
  })
 //拦截器(返回拦截) 只有接口错误做处理，正确不做处理
http.interceptors.response.use(res => {
  window.krpano.call('skin_showloading(false)')
  // window._global.isLoading= false
  if (res.status === 200 ) {
    //判断验证信息
    if(res.data.code !== '000000' ){
      Toast(res.data.message)
      if(res.data.code === '100005' ){
        // 登入超时跳刀登入页面重新登入
        window.localStorage.removeItem('token');
      }
      
    } else{
      
    }
  }else{
    Toast('网络错误')
  }
  return res.data
}, (err) => {   // 这里是500
  Toast('网络错误')
  // err.message= '请检查网络'
  // return Promise.reject(err)
})
export default http



// WEBPACK FOOTER //
// ./src/config/axios.js